const getUserSub = () => window.tokenParsed?.sub || 'anonymous'

export function getThresholdStorageKey(yearMonth, thresholdId) {
  return `paywall-threshold-${getUserSub()}-${yearMonth}-${thresholdId}`
}

export function wasPaywallThresholdShown(yearMonth, thresholdId) {
  if (!yearMonth || !thresholdId) return false
  return (
    localStorage.getItem(getThresholdStorageKey(yearMonth, thresholdId)) ===
    'true'
  )
}

export function markPaywallThresholdShown(yearMonth, thresholdId) {
  if (!yearMonth || !thresholdId) return
  localStorage.setItem(getThresholdStorageKey(yearMonth, thresholdId), 'true')
}
